export type UserRole = 'super_admin' | 'org_admin' | 'dep_admin' | 'site_manager' | 'viewer';

export const ROLE_LEVELS: Record<UserRole, number> = {
  super_admin: 100,
  org_admin: 80,
  dep_admin: 60,
  site_manager: 40,
  viewer: 20
};

export function hasMinRole(userRole: UserRole | null | undefined, minRole: UserRole): boolean {
  if (!userRole) {
    return false;
  }
  return ROLE_LEVELS[userRole] >= ROLE_LEVELS[minRole];
}
